// Import worker URL using Vite's ?url suffix for proper bundling
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { pdfjs } from 'react-pdf';

let isInitialized = false;

/**
 * Initialize PDF.js with the correct worker configuration
 * This function should be called once at app startup
 */
export const initializePdfJs = () => {
    if (isInitialized) {
        console.warn('PDF.js already initialized');
        return;
    }

    // Configure PDF.js worker - this works in both dev and production
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    isInitialized = true;

    console.log('✅ PDF.js worker initialized');
};

/**
 * Check if PDF.js has been initialized
 */
export const isPdfJsInitialized = () => isInitialized;
